module.exports = __webpack_public_path__ + "static/media/logo-voala-25.a1d1505a.png";